module.exports = __webpack_public_path__ + "img/order.ceaa4149.jpg";